
import clientAPI from "@/api/ClientAPIMixin.js";

function timeToDecimal(t) {
    var arr = t.split(':');
    var dec = parseInt((arr[1] / 6) * 10, 10);

    return parseFloat(parseInt(arr[0], 10) + '.' + (dec < 10 ? '0' : '') + dec);
}

export const plannerstore = {
    namespaced: true,

    state: () => ({
        CalendarDateStart: new Date(),
        CalendarDateEnd: null,
        UnplannedJobList: [],
        UnplannedJobListLoading: true,
        AppointmentList: [],
        AppointmentListLoading: true,
        BookableUsers: [],
        BookableUserListLoading: true,
        Departments: [],
        SConf: null,
        SearchWord: null,
    }),


    mutations: {
        SET_START_DATE(state, date) { state.CalendarDateStart = date; },

        SET_UNPLANNEDJOBS_LIST(state, list) {
            state.UnplannedJobList = list;
            state.UnplannedJobListLoading = false;
        },

        SET_BOOKABLE_USERS_LIST(state, list) {
            list.forEach((element) => {
                element.id = element.Id;
            });
            state.BookableUsers = list;
        },

        SET_FILTERED_BOOKABLE_USERS_LIST(state, list) { state.FilteredBookableUsers = list; },

        SET_DEPARTMENT_LIST(state, list) {
            list.forEach((element) => {
                element.id = element.Id;
            });
            state.Departments = list;
        },

        SET_SEARCH_WORD(state, searchword) {
            state.SearchWord = searchword;
        },
    },


    actions: {
        SetCalendarStartDate({ commit }, date) {
            commit('SET_START_DATE', date)
        },

        SetUnplannedJobsListWidth({ commit }, update) {
            commit('SET_UNPLANNEDJOBS_LIST_WIDTH', update)
        },
        async GetUnplannedJobs({ state, commit, rootGetters }) {
            state.UnplannedJobListLoading = true;
            var statusfilter = rootGetters['prefrences/Prefrence']('PlannerJobListStatusFilterMultiple');
            var subStatusfilter = rootGetters['prefrences/Prefrence']('PlannerJobListSubStatusFilter');
            var preferenceDepartmentfilter = rootGetters["prefrences/Prefrence"]("JobListFilterOrderDepartmentDefault");
            var dynamicDepartmentfilter = rootGetters["prefrences/Prefrence"]("PlannerJobListDepartmentFilter");
            var departmentFilter = dynamicDepartmentfilter ?? preferenceDepartmentfilter ?? null;

            var filter = {
                Page: 1,
                ItemsPerPage: 999,
                SearchWord: state.SearchWord,
                JobStatusIdList: statusfilter,
                JobSubStatusIdList: subStatusfilter != null ? [subStatusfilter] : null,
                OrderDepartmentIdList: departmentFilter,
                JobTypeIdList: null,
                JobPriorityIdList: null,
            };
            var list = clientAPI.methods.getJobListFromFilter(filter)
                .then(response => {
                    response = response?.Content?.map(e => {
                        e.hover = false;
                        e.selected = false;
                        return e;
                    })
                    commit('SET_UNPLANNEDJOBS_LIST', response)
                    return response;
                })
                .catch((exception) => console.log(exception)
                );
            return list;
        },
        SetUnplannedJobsList({ commit }, update) {
            commit('SET_UNPLANNEDJOBS_LIST', update)
        },
        RemoveUnplannedJobById({ state, commit }, jobId) {
            var list = Object.assign([], state.UnplannedJobList);
            list = list.filter(j => j.Id !== jobId);
            commit('SET_UNPLANNEDJOBS_LIST', list)
        },

        async GetBookableUsers({ commit }) {
            //console.log('Getting bookable users')
            var list = clientAPI.methods.getBookableUsers()
                .then(response => {
                    commit('SET_BOOKABLE_USERS_LIST', response)
                    commit('SET_FILTERED_BOOKABLE_USERS_LIST', response)
                    return response;
                })
                .catch((exception) => console.log(exception)
                );
            return list;
        },

        async GetDepartments({ commit }) {
            //console.log('Getting departments')
            var filter = {
                "ItemsPerPage": 150,
                "Page": 1
            };
            var list = clientAPI.methods.getDepartmentListFromFilter(filter)
                .then(response => {
                    var list = response.Content || response;
                    commit('SET_DEPARTMENT_LIST', list)
                    return list;
                })
                .catch((exception) => console.log(exception)
                );
            return list;
        },

        async checkIdIsFrontendOnly(notused, id) {
            var result = (!id || (' ' + id).includes("_generated"));
            //console.log('checkIdIsFrontendOnly', result, id);
            return result;
        },

        SetSearchWord({ commit }, searchword) {
            commit('SET_SEARCH_WORD', searchword)
        },
    },


    getters: {
        LimitToWorkHours: (state, getters, rootState, rootGetters) => {
            return rootGetters["prefrences/Prefrence"]("LimitToWorkHours");
        },
        WorkhourStart: (state, getters, rootState) => {
            return timeToDecimal(rootState.GlobalSettings.WorkHourStart)
        },
        WorkhourEnd: (state, getters, rootState) => {
            return timeToDecimal(rootState.GlobalSettings.WorkHourEnd)
        },

        CalendarDateStart: state => {
            return state.CalendarDateStart;
        },
        CalendarDateEnd: state => {
            return state.CalendarDateEnd;
        },

        ShowJobs: (state, getters, rootState, rootGetters) => {
            return rootGetters["prefrences/Prefrence"]("PlannerJobListShow");
        },
        UnplannedJobList: state => {
            return state.UnplannedJobList;
        },
        UnplannedJobListLoading: state => {
            return state.UnplannedJobListLoading;
        },

        AppointmentList: state => {
            return state.AppointmentList;
        },
        AppointmentListLoading: state => {
            return state.AppointmentListLoading;
        },

        BookableUsers: state => {
            return state.BookableUsers;
        },
        FilteredBookableUsers: (state, getters, rootState, rootGetters) => {
            var prefrence = rootGetters["prefrences/Prefrence"]("PlannerUserFilter");
            if (prefrence.length > 0) {
                return prefrence;
            }
            else {
                return state.BookableUsers;
            }
        },

        BookableUserById: state => (userid) => {
            return state.BookableUsers.find(user => user.Id === userid);
        },

        Departments: state => {
            return state.Departments;
        },

        SearchWord: state => {
            return state.SearchWord;
        },
    }
}